<app-dialog-base [showLoadingSpinner]="uiState == uiStateEnumForTemplate.ShowLoading">
  <span dialog-title data-testid="edit-translation-dialog-title">{{ dialogTitle }} - {{ data.category.Name }}</span>

  <ng-container dialog-content>
    @if (uiState === uiStateEnumForTemplate.ShowData) {
      <form [formGroup]="translationForm" class="translation-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Language</mat-label>
          <mat-select formControlName="languageCode"
                      data-testid="language-select"
                      required>
            @for (lang of selectableLanguages; track lang.code) {
              <mat-option [value]="lang.code" [attr.data-testid]="'language-option-' + lang.code">
                {{ lang.name }} ({{ lang.code.toUpperCase() }})
              </mat-option>
            }
          </mat-select>
          @if (languageCodeControl.hasError('required')) {
            <mat-error data-testid="language-error">Language is required</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>User-Facing Message</mat-label>
          <textarea matInput
                    formControlName="message"
                    data-testid="translation-message-input"
                    rows="4"
                    placeholder="Enter the user-facing error message for this category"
                    required></textarea>
          @if (messageControl.hasError('required')) {
            <mat-error data-testid="message-error">Message is required</mat-error>
          }
        </mat-form-field>

        <p class="hint-text">
          This message will be displayed to users when any error in the "{{ data.category.Name }}" category occurs.
        </p>
      </form>
    }
  </ng-container>

  <ng-container actions>
    <button mat-button
            data-testid="cancel-translation-button"
            (click)="dialogRef.close(false)">
      Cancel
    </button>
    <button mat-raised-button
            color="primary"
            data-testid="save-translation-button"
            (click)="saveTranslation()"
            [disabled]="uiState === uiStateEnumForTemplate.ShowLoading || translationForm.invalid">
      Save
    </button>
  </ng-container>
</app-dialog-base>
